import { convertBlobToBase64 } from "../components/FileGenerator/utils";

export async function searchChildrenByDriveId(token, siteId, driveItemId) {
    let serverURL = `${process.env.REACT_APP_BASE_URL}/files/searchChildrenByDriveId/${siteId}/${driveItemId}`;
    let params = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            token: token,
        },
    }
    let result = [];
    await fetch(serverURL, params)
        .then(r => r.json())
        .then(r => {
            result = r;
        });
    return result;
}

let trimKey = key => {
    return key && key.replace(/([\\|/*?":(){}<>[\]])/g, "")
}

/*Files*/
export async function searchFileByKey(token, siteId, listId, webUrl, key, folderType, isConsultant) {
    //  'safeKey' takes 'key' (terms to search) without fql query expressions
    let safeKey = (trimKey(key) && trimKey(key) !== "") ? trimKey(key) : "*"
    let encodedSafeKey = encodeURIComponent(safeKey)

    let serverURL = `${process.env.REACT_APP_BASE_URL}/files/searchFilesByKey/${siteId}/${listId}/${encodedSafeKey}/${isConsultant}`;

    let params = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            token: token,
            webUrl: webUrl,
            foldertype: folderType
        },
    };
    let files = [];
    await fetch(serverURL, params)
        .then(r => r.json())
        .then(r => {
            files = r;
        });
    return files;
}

export async function searchEmptyContentFile(token) {
    let serverURL =
        process.env.REACT_APP_BASE_URL + "/files/searchEmptyFileContent";
    let params = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": 'GET, OPTIONS,POST',
            "Access-Control-Allow-Credentials": true,
            token: token,
        },
    };
    let content = "";
    await fetch(serverURL, params)
        .then(r => r.json())
        .then(r => {
            content = r;
        });
    return content;
}

export async function searchFileContentByFileId(token, siteId, fileId) {
    let serverURL = `${process.env.REACT_APP_BASE_URL}/files/searchFileContentByFileId/${siteId}/${fileId}`;
    let params = {
        method: "GET",
        headers: {
            "Content-Type": "*",
            token: token,
        },
    };
    let content = "";
    await fetch(serverURL, params)
        .then(r => r.json())
        .then(r => {
            content = r;
        });
    return content;
}

export async function searchReportTemplateFile(token, webUrl, siteId, language) {
    let urlFile = "";
    let serverURL = `${process.env.REACT_APP_BASE_URL}/files/searchReportTemplateFile/${siteId}/${language}`;
    let params = {
        method: "GET",
        headers: {
            "Content-Type": "*",
            token: token,
            weburl: webUrl
        },
    };

    await fetch(serverURL, params)
        .then(r => r.text())
        .then(r => {
            urlFile = r;
            return urlFile;
        });
    return urlFile;
}

export async function updateFileLocation(token, siteId, fileId, path) {
    let serverURL = `${process.env.REACT_APP_BASE_URL}/files/updateFileLocation/${siteId}/${fileId}`;
    let params = {
        method: "PUT",
        headers: {
            'Content-Type': '*',
            token: token,
            path: path,
        },
    };
    let result = '';
    await fetch(serverURL, params)
        .then(r => {
            result = r;
        });
    return result;
}

export async function updateFileContentByFileId(token, siteId, fileId, content) {
    let serverURL = `${process.env.REACT_APP_BASE_URL}/files/updateFileContentByFileId/${siteId}/${fileId}`;
    let params = {
        method: "PUT",
        headers: {
            'Content-Type': 'application/json',
            token: token,
        },
        body: JSON.stringify(content),
    };
    let result = "";
    await fetch(serverURL, params)
        .then(r => {
            result = r;
        });
    return result;
}

export async function renameFileById(token, siteId, fileId, content) {
    let serverURL = `${process.env.REACT_APP_BASE_URL}/files/renameFile/${siteId}/${fileId}`;
    let params = {
        method: "PUT",
        headers: {
            'Content-Type': 'application/json',
            token: token,
        },
        body: JSON.stringify(content),
    };
    let result = "";
    await fetch(serverURL, params)
        .then(r => {
            result = r;
        });
    return result;
}

/*Permissions*/
export async function changePermission(token, siteId, fileId, email, permission) {
    let serverURL =
        process.env.REACT_APP_BASE_URL + "/files/addPermissionToFile/" + siteId + "/" + fileId + "/" + email + "/" + permission;
    let params = {
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            token: token,
        },
    };
    let result = '';
    await fetch(serverURL, params)
        .then((response) => {
            return response.json();
        })
        .then((res) => {
            result = res;
        });
    return result;
}

export let updateFilePermission = async (token, siteId, fileId, email, roles) => {
    let updateUrl = `${process.env.REACT_APP_BASE_URL}/files/updateFilePermission/${siteId}/${fileId}/${email}`
    let options = {
        method: "PUT",
        headers: {
            'Content-Type': '*',
            token: token,
            roles: JSON.stringify(roles)
        }
    }
    return await fetch(updateUrl, options)
        .then(r => r.json())
}

export async function sendEmail(email, subject, texts) {
    let serverURL =
        process.env.REACT_APP_BASE_URL + "/files/sendEmail";
    let params = {
        method: "POST",
        headers: {
            'Content-type': 'application/json'
        },
        body: JSON.stringify({
            email,
            subject,
            texts
        })
    };
    let result = ''
    await fetch(serverURL, params)
        .then((response) => {
            return response.json();
        })
        .then((res) => {
            result = res.status;
        });
    return result;
}

/*Users*/
export async function searchAllUsers(graphAccessToken) {
    let serverURL =
        process.env.REACT_APP_BASE_URL + "/users/searchAllUsers";
    let params = {
        method: "GET",
        headers: {
            "Content-Type": "*",
            token: graphAccessToken,
        },
    };
    let users = [];
    await fetch(serverURL, params)
        .then((response) => {
            return response.json();
        })
        .then((res) => {
            users = res;
        });
    return users;
}

export let searchUserPhoto = async (token, userId) => {
    let serverURL = `${process.env.REACT_APP_BASE_URL}/users/searchUserPhoto/${userId}`
    let params = {
        method: "GET",
        headers: {
            "Content-Type": "*",
            token: token,
        }
    }
    return await fetch(serverURL, params)
}

export let searchMembersByGroupId = async (token, groupId) => {
    let url = `${process.env.REACT_APP_BASE_URL}/users/searchMembersByGroupId/${groupId}`;
    let params = {
        method: "GET",
        headers: {
            "Content-Type": "json",
            token: token,
        }
    }
    let members = [];
    await fetch(url, params)
        .then(r => r.json())
        .then(r => {
            members = r;
        })
    return members;
}

export let verifyInGroup = async (token, groupId, userId) => {
    let url = `${process.env.REACT_APP_BASE_URL}/users/verifyInGroup/${groupId}/${userId}`;
    let params = {
        method: "GET",
        headers: {
            "Content-Type": "json",
            token: token,
        }
    }
    let members = [];
    await fetch(url, params)
        .then(r => r.json())
        .then(r => {
            members = r;
        })
    return members;
}

/* Folder */
export async function createNewFolder(token, siteId, parentItemId, folderName) {
    let encodedFolderName = encodeURIComponent(folderName)
    let serverURL = `${process.env.REACT_APP_BASE_URL}/clients/createFolder/${siteId}/${parentItemId}/${encodedFolderName}`;

    let params = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            token: token,
        },
    };
    let result = "";
    await fetch(serverURL, params)
        .then((response) => {
            return response.json();
        })
        .then((res) => {
            result = res;
        });
    return result;
}

export async function deleteFolder(token, siteId, itemId) {
    let serverURL = `${process.env.REACT_APP_BASE_URL}/files/deleteFolder/${siteId}/${itemId}`;
    let params = {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
            token: token,
        },
    };
    let result = "";
    await fetch(serverURL, params)
        .then((response) => {
            result = response
        })
    return result;
}

export async function manageFileChangesPermission(token, siteId, fileId, consultantEmail, emailBeforeChange, permissionCode) {
    let serverURL = `${process.env.REACT_APP_BASE_URL}/files/manageFileChangesPermission`;
    let params = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            token: token,
        },
        body: JSON.stringify({
            siteId: siteId,
            fileId: fileId,
            consultantEmail: consultantEmail,
            emailBeforeChange: emailBeforeChange,
            permissionCode: permissionCode
        })
    };
    let result = "";
    await fetch(serverURL, params)
        .then((response) => {
            result = response
        })
    return result;
}

export async function deletePermissionFromFile(token, siteId, fileID, member) {
    let serverURL = `${process.env.REACT_APP_BASE_URL}/files/deletePermissionFromFile/${siteId}/${fileID}/${member}`;
    let params = {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
            token: token,
        },
    };
    let result = "";
    await fetch(serverURL, params)
        .then((response) => {
            result = response
        })
    return result;
}

/* Opportunity */
export async function createNewFile(token, siteId, driveItemId, fileName, content) {
    let encodedFileName = encodeURIComponent(fileName)
    let serverURL = `${process.env.REACT_APP_BASE_URL}/files/createFile/${siteId}/${driveItemId}/${encodedFileName}`;
    let params = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            token: token,
        },
        body: JSON.stringify(content),
    };
    let result = "";
    await fetch(serverURL, params)
        .then(r => {
            return r.json();
        })
        .then(r => {
            result = r;
        });

    return result;
}

/* Dictionary */
export async function getLocalDictionary(token, siteId) {
    let serverURL = `${process.env.REACT_APP_BASE_URL}/files/getLocalDictionary/${siteId}`;
    let params = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            token: token
        }
    };
    let result;
    await fetch(serverURL, params)
        .then(r => {
            return r.json();
        })
        .then(r => {
            result = r;
        });

    return result;
}

export let searchCorrection = async (lang, misspell) => {
    let encodedMisspell = encodeURIComponent(misspell)
    let url = `${process.env.REACT_APP_BASE_URL}/dictionaries/searchCorrection/${lang}/${encodedMisspell}`
    let options = {
        method: "GET", headers: {
            "Content-Type": "application/json",
        }
    }
    return await fetch(url, options)
        .then(r => r.json())
}

//              HARD CODED IN .ENV FILE
/********************************************************
                REACT_APP_SITE_NAME
                REACT_APP_SALES_GROUP_ID
                REACT_APP_ADMIN_GROUP_ID
                REACT_APP_HR_GROUP_ID
********************************************************/
/*Lists*/
export let searchListByName = async (token, siteId) => {
    let url = `${process.env.REACT_APP_BASE_URL}/files/searchListByName/${siteId}`
    let params = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            token: token,
        },
    }
    let list = {}
    await fetch(url, params)
        .then(r => r.json())
        .then(r => {
            list = r
        })
    return list
}

/*Sites*/
export async function searchSiteByName(token) {
    let serverURL = process.env.REACT_APP_BASE_URL + "/files/searchSiteByName/";
    let params = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            token: token,
        },
    };
    let site = "";
    await fetch(serverURL, params)
        .then(r => r.json())
        .then(r => {
            site = r;
        });
    return site;
}

export async function addMemberToSite(token, groupId, userId) {
    let serverURL = process.env.REACT_APP_BASE_URL + "/files/addMemberToSite";
    let params = {
        method: "POST",
        headers: {
            'Content-type': 'application/json',
            token: token
        },
        body: JSON.stringify({
            groupId: groupId,
            userId: userId
        })
    };
    let result;
    await fetch(serverURL, params)
        .then((response) => {
            return response.json();
        })
        .then((res) => {
            result = res;
        });
    return result;
}

/*Drives*/
export async function searchDriveByPath(token, siteId, path) {
    let serverURL = `${process.env.REACT_APP_BASE_URL}/files/searchDriveByPath/${siteId}`;
    let params = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            token: token,
            path: path,
        },
    };
    let drive = "";
    await fetch(serverURL, params)
        .then(r => r.json())
        .then(r => {
            drive = r;
        });
    return drive;
}

export async function convertDocxFileToPdf(token, siteId, fileName, format) {
    let serverURL = `${process.env.REACT_APP_BASE_URL}/files/convertFile/${siteId}/${fileName}/${format}`
    let params = {
        method: "GET",
        headers: {
            "Content-Type": "*",
            token: token,
        }
    }
    let response
    await fetch(serverURL, params).then((r) => {
        response = r.blob()
    })
    return response
}

export const uploadFileToSharePoint = async (token, siteId, fileName, content) => {
    let convertUrl = `${process.env.REACT_APP_BASE_URL}/files/uploadFile/${siteId}/${fileName}`
    const blobToBase64 = await convertBlobToBase64(content);
    let options = {
        method: "PUT",
        headers: {
            token: token,
            "Content-Type": 'application/json',
        },
        body: JSON.stringify({ blobToBase64 })
    };

    return await fetch(convertUrl, options);
};

export const deleteFileFromSharePoint = async (token, siteId, fileName) => {
    let convertUrl = `${process.env.REACT_APP_BASE_URL}/files/deleteFile/${siteId}/${fileName}`
    const headers = {
        token: token,
        "Content-Type": "application/json",
        "Accept": "application/json",
    };
    const response = await fetch(convertUrl, {
        method: "DELETE",
        headers,
    });
    return response
};
export {
    createNewFolder as createNewOpportunity,
    createNewFolder as createNewClient,
    createNewFile as createNewCV,
    deleteFolder as deleteOpportunity,
    deleteFolder as deleteClient,
    deleteFolder as deleteFile
}